import { useEffect, useState } from "react";
import { useDataProvider, type Identifier } from "ra-core";
import { Progress } from "@/components/ui/progress";

import type { CampaignProgressSummary } from "../types";

export const CampaignProgressBySalesperson = ({
  campaignId,
  onSelectSalesperson,
  selectedSalesId,
}: {
  campaignId: Identifier;
  onSelectSalesperson?: (id: Identifier | null) => void;
  selectedSalesId?: Identifier | null;
}) => {
  const dataProvider = useDataProvider();
  const [progress, setProgress] = useState<CampaignProgressSummary | null>(
    null,
  );

  useEffect(() => {
    (dataProvider as any)
      .getCampaignProgress(campaignId)
      .then(setProgress)
      .catch(() => setProgress(null));
  }, [campaignId, dataProvider]);

  if (!progress?.by_salesperson?.length) return null;

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold">By salesperson</h3>
      {progress.by_salesperson.map((row) => {
        const pct = row.total > 0 ? Math.round((row.completed / row.total) * 100) : 0;
        const selected = selectedSalesId === row.sales_id;
        return (
          <button
            key={row.sales_id}
            type="button"
            className={`w-full text-left rounded-md border p-3 space-y-2 ${selected ? "border-primary bg-muted/50" : ""}`}
            onClick={() =>
              onSelectSalesperson?.(selected ? null : row.sales_id)
            }
          >
            <div className="flex justify-between text-sm font-medium">
              <span>{row.name}</span>
              <span className="text-muted-foreground">
                {row.completed}/{row.total}
              </span>
            </div>
            <Progress value={pct} className="h-2" />
            {row.overdue > 0 && (
              <p className="text-xs text-destructive">{row.overdue} overdue</p>
            )}
          </button>
        );
      })}
    </div>
  );
};
